// components/ProductCard.jsx
//
// One product tile. Buy button checks login before proceeding to
// checkout. Shows NEW / POPULAR badges, price note, and a WhatsApp
// confirm button - all matching the dark HUD theme.
//
// NOTE: product.description is intentionally NOT rendered here anymore.
// Descriptions vary a lot in length across your catalog, and showing
// them on the card made cards different heights in the grid. The
// description now only shows on the Checkout page (after clicking Buy
// Now) - see pages/Checkout.jsx.

import React from 'react';
import { useNavigate } from 'react-router-dom';

function ProductCard({ product, newBadgeWindowDays = 7 }) {
  const navigate = useNavigate();

  const handleBuyClick = () => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }
    navigate(`/checkout/${product._id}`);
  };

  const outOfStock = product.quantity <= 0;

  const isNew =
    product.createdAt &&
    (Date.now() - new Date(product.createdAt).getTime()) / (1000 * 60 * 60 * 24) <= newBadgeWindowDays;

  const isFeatured = ['netflix', 'amazon prime video'].includes(product.name?.toLowerCase());

  return (
    <div className="product-card hud">
      <div style={{ position: 'absolute', top: '10px', left: '10px', display: 'flex', flexDirection: 'column', gap: '4px', zIndex: 1 }}>
        {isNew && <span className="badge badge-new">NEW</span>}
        {isFeatured && <span className="badge badge-popular">POPULAR</span>}
      </div>

      <img src={product.icon || 'https://via.placeholder.com/220x140/121828/8992A9?text=No+Image'} alt={product.name} />
      <h3 style={{ margin: '12px 0 10px', fontSize: '16px' }}>{product.name}</h3>

      {product.contactForPrice ? (
        <p className="price-tag">Contact for Price</p>
      ) : (
        <>
          <p className="price-tag">
            {product.pricingTiers && product.pricingTiers.length > 1
              ? `From ₹${Math.min(...product.pricingTiers.map((t) => t.price))}`
              : `₹${product.price}`}
          </p>
          <p style={{ fontSize: '11px', color: '#6b7285', fontStyle: 'italic', margin: '3px 0 8px' }}>
            Price & validity may vary time to time. Please contact on WhatsApp for confirmation.
          </p>
          <p style={{ fontSize: '13px', color: outOfStock ? '#ff4757' : '#3ea567', margin: '0 0 10px' }}>
            {outOfStock ? 'Out of Stock' : `${product.quantity} available`}
          </p>
        </>
      )}

      {!product.contactForPrice && (
        <button onClick={handleBuyClick} disabled={outOfStock} className="btn-primary" style={{ width: '100%', marginBottom: '8px' }}>
          {outOfStock ? 'Unavailable' : 'Buy Now'}
        </button>
      )}

      <a
        href={`https://wa.me/918863889778?text=${encodeURIComponent(
          product.contactForPrice
            ? `Hi, I'm interested in: ${product.name}. Please share pricing details.`
            : `Hi, I want to confirm the current price & validity for: ${product.name}`
        )}`}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-whatsapp"
        style={{ width: '100%' }}
      >
        <svg width="15" height="15" viewBox="0 0 24 24" fill="white">
          <path d="M12.001 2.001C6.476 2.001 2 6.477 2 12.002c0 1.94.535 3.755 1.463 5.307L2 22l4.828-1.42a9.94 9.94 0 0 0 5.173 1.42h.001c5.524 0 10-4.476 10-10.001 0-2.67-1.04-5.18-2.929-7.069A9.935 9.935 0 0 0 12.001 2.001zm0 18.202h-.001a8.19 8.19 0 0 1-4.176-1.144l-.3-.178-3.106.914.83-3.03-.196-.31a8.19 8.19 0 0 1-1.253-4.363c0-4.532 3.688-8.22 8.204-8.22 2.19 0 4.25.854 5.8 2.406a8.146 8.146 0 0 1 2.401 5.816c0 4.531-3.687 8.109-8.203 8.109z" />
        </svg>
        {product.contactForPrice ? 'Enquire on WhatsApp' : 'Confirm on WhatsApp'}
      </a>
    </div>
  );
}

export default ProductCard;
